import React, { type ForwardedRef } from 'react'

/* eslint-disable */
const withForwardedRefSection = <T, >(Component: any) => {
  return React.forwardRef((props: T & {friendlyId?: string | null}, ref: ForwardedRef<HTMLElement>) => {
    return <section ref={ref} id={props?.friendlyId ?? ''}>
      <Component {...props} />
    </section>
  })
}


export default withForwardedRefSection
